export default {"src":"/_next/static/media/checkmark-yellow-black-border.42b8d751.svg","height":76,"width":76,"blurWidth":0,"blurHeight":0};